import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CompanyDTO } from 'src/app/model/company.dto';
import { Options } from 'selenium-webdriver/edge';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private baseUrl:String = environment.adminUrl;
  private baseUrll = environment.baseUrl

  constructor(private http:HttpClient) { }

  getToken(emailId:String){
    return this.http.get(this.baseUrl + `/admin/user/authorize/${emailId}`);
  }

  addCompany(companyDTO:CompanyDTO){
    return this.http.post(this.baseUrl + `/adminservice/company`,companyDTO,{
      headers:new HttpHeaders().append("token",localStorage.getItem("token"))
    });
  }

  getCompanies(){
    return this.http.get(this.baseUrl +`/adminservice/companies`,{
      headers:new HttpHeaders().append("token",localStorage.getItem("token"))
    });
  }

  updateCompany(data){
    return this.http.put(this.baseUrl + `/adminservice/company`,data,{
      headers:new HttpHeaders().append("token",localStorage.getItem("token"))
    });
  }

  postWithTokens(options){
    console.log("this.baseurl: ", this.baseUrll);
    console.log("options purpose: ", options.purpose);
    
    
    return this.http.post(this.baseUrll + '/template', options.data ,{
      headers:new HttpHeaders().append("Authorization",localStorage.getItem("token"))
    });
  }
}
